/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserAccessType } from './UserAccessType';
import {
    UserAccessTypeFromJSON,
    UserAccessTypeFromJSONTyped,
    UserAccessTypeToJSON,
    UserAccessTypeToJSONTyped,
} from './UserAccessType';

/**
 * 
 * @export
 * @interface ApprovedAccessResponse
 */
export interface ApprovedAccessResponse {
    /**
     * 
     * @type {string}
     * @memberof ApprovedAccessResponse
     */
    userDisplayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAccessResponse
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAccessResponse
     */
    userEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAccessResponse
     */
    userMfaPhone?: string | null;
    /**
     * 
     * @type {UserAccessType}
     * @memberof ApprovedAccessResponse
     */
    accessType?: UserAccessType;
    /**
     * 
     * @type {any}
     * @memberof ApprovedAccessResponse
     */
    accessId?: any | null;
    /**
     * 
     * @type {Date}
     * @memberof ApprovedAccessResponse
     */
    assignedOn?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAccessResponse
     */
    accessName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAccessResponse
     */
    applicationName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAccessResponse
     */
    organizationName?: string | null;
    /**
     * 
     * @type {any}
     * @memberof ApprovedAccessResponse
     */
    organizationId?: any | null;
}



/**
 * Check if a given object implements the ApprovedAccessResponse interface.
 */
export function instanceOfApprovedAccessResponse(value: object): value is ApprovedAccessResponse {
    return true;
}

export function ApprovedAccessResponseFromJSON(json: any): ApprovedAccessResponse {
    return ApprovedAccessResponseFromJSONTyped(json, false);
}

export function ApprovedAccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApprovedAccessResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userDisplayName': json['userDisplayName'] === undefined ? undefined : json['userDisplayName'] === null ? null : json['userDisplayName'],
        'userId': json['userId'] === undefined ? undefined : json['userId'] === null ? null : json['userId'],
        'userEmail': json['userEmail'] === undefined ? undefined : json['userEmail'] === null ? null : json['userEmail'],
        'userMfaPhone': json['userMfaPhone'] === undefined ? undefined : json['userMfaPhone'] === null ? null : json['userMfaPhone'],
        'accessType': json['accessType'] == null ? undefined : UserAccessTypeFromJSON(json['accessType']),
        'accessId': json['accessId'] === undefined ? undefined : json['accessId'] === null ? null : json['accessId'],
        'assignedOn': json['assignedOn'] === undefined ? undefined : json['assignedOn'] === null ? null : (new Date(json['assignedOn'])),
        'accessName': json['accessName'] === undefined ? undefined : json['accessName'] === null ? null : json['accessName'],
        'applicationName': json['applicationName'] === undefined ? undefined : json['applicationName'] === null ? null : json['applicationName'],
        'organizationName': json['organizationName'] === undefined ? undefined : json['organizationName'] === null ? null : json['organizationName'],
        'organizationId': json['organizationId'] === undefined ? undefined : json['organizationId'] === null ? null : json['organizationId'],
    };
}

export function ApprovedAccessResponseToJSON(json: any): ApprovedAccessResponse {
    return ApprovedAccessResponseToJSONTyped(json, false);
}

export function ApprovedAccessResponseToJSONTyped(value?: ApprovedAccessResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userDisplayName': value['userDisplayName'],
        'userId': value['userId'],
        'userEmail': value['userEmail'],
        'userMfaPhone': value['userMfaPhone'],
        'accessType': UserAccessTypeToJSON(value['accessType']),
        'accessId': value['accessId'],
        'assignedOn': value['assignedOn'] == null ? value['assignedOn'] : value['assignedOn'].toISOString(),
        'accessName': value['accessName'],
        'applicationName': value['applicationName'],
        'organizationName': value['organizationName'],
        'organizationId': value['organizationId'],
    };
}

